import { ADDRESS_ENV, EXPECTED_CHAIN_ID, envAddress, envString, type HexAddress } from "./config";

export const PLANNED_MAINNET_NFT_ADDRESS: HexAddress = "0xfFbA7FB7D845E01A1563522499aC8C5BE40C3461";
export const PLANNED_MAINNET_CAPE_CONTRACT: HexAddress = "0x84B3eb1Ee2694c4f18712949c80B2922deD4C079";

export function getDisplayNftAddress(): HexAddress {
  return envAddress(ADDRESS_ENV.nft) ?? PLANNED_MAINNET_NFT_ADDRESS;
}

export function getDisplayCapeTokenAddress(): HexAddress {
  return envAddress(ADDRESS_ENV.capeToken) ?? PLANNED_MAINNET_CAPE_CONTRACT;
}

export function shortAddress(address: string): string {
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

export function getExplorerAddressUrl(address: string): string {
  const base = EXPECTED_CHAIN_ID === 11155111 ? "https://sepolia.etherscan.io" : "https://etherscan.io";
  return `${base}/address/${address}`;
}

export function getCodeApeXUrl(): string {
  return envString("VITE_CODE_APE_X_URL") ?? "https://x.com/codeape";
}

export function getUniswapTradeUrl(): string {
  const configured = envString("VITE_UNISWAP_TRADE_URL");
  if (configured) return configured;
  const cape = getDisplayCapeTokenAddress();
  return `https://app.uniswap.org/swap?chain=mainnet&outputCurrency=${cape}`;
}
